// Theme toggle strings (auto-merged by lib/i18n.ts).
export const en = {
  'ds.themetoggle.label': 'Toggle light/dark theme',
}

export const zhTW = {
  'ds.themetoggle.label': '切換淺色／深色主題',
}
